import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgWinter = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.684 2.22a.75.75 0 0 0-1.06 1.06l2.626 2.627v5.343H5.907L3.28 8.623a.75.75 0 0 0-1.06 1.061L4.535 12 2.22 14.316a.75.75 0 1 0 1.06 1.06l2.627-2.626h5.343v5.343L8.623 20.72a.75.75 0 1 0 1.061 1.06L12 19.465l2.316 2.315a.75.75 0 1 0 1.06-1.06l-2.626-2.627V12.75h5.343l2.627 2.626a.75.75 0 0 0 1.06-1.06L19.465 12l2.315-2.316a.75.75 0 1 0-1.06-1.06l-2.627 2.626H12.75V5.907l2.627-2.627a.75.75 0 1 0-1.061-1.06L12 4.535zM6.49 6.489a.75.75 0 0 1 1.06 0l2.135 2.134a.75.75 0 0 1-1.06 1.061L6.489 7.55a.75.75 0 0 1 0-1.061m3.195 8.887a.75.75 0 0 0-1.06-1.06L6.489 16.45a.75.75 0 0 0 1.06 1.061zm7.827-8.887a.75.75 0 0 1 0 1.06l-2.134 2.135a.75.75 0 1 1-1.061-1.06l2.135-2.135a.75.75 0 0 1 1.06 0m-2.134 7.827a.75.75 0 1 0-1.061 1.06l2.135 2.135a.75.75 0 1 0 1.06-1.06z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgWinter;
